import { Injectable } from '@angular/core';
import { AngularFireStorage } from 'angularfire2/storage';

@Injectable()
export class StorageData {

  constructor(
    private storage: AngularFireStorage
  ) { }

  push(file: File, path: string) {
    return this.storage.upload(path, file);
  }

  // set(name: string, value: string) {
  //   window.localStorage.setItem(name, value);
  // }

  // get(name: string) {
  //   window.localStorage.getItem(name);
  // }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/storage.ts